import { NgModule, APP_INITIALIZER, ErrorHandler, LOCALE_ID } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ClipboardModule } from "ngx-clipboard";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CustomPaginatorIntl } from "./core/countries-managment/i18n/custom-paginator-intl";
import { ChunkErrorHandler } from "./core/errors/chunk-error-handler";
import localeEsAr from "@angular/common/locales/es-AR";
import { registerLocaleData } from "@angular/common";
// Highlight JS
import { HighlightModule, HIGHLIGHT_OPTIONS } from "ngx-highlightjs";
// #fake-end#
import { FileMaterialModule } from "./modules/document-library/material-module";
import { DialogConfirmComponent } from "./modules/shared/dialog/dialog-confirm.component";
import { SharedModule } from "./modules/shared/shared.module";
import { IndividualsModule } from "./modules/individuals/individuals.module";
import { SplashScreenModule } from "./pages/splash-screen/splash-screen.module";
import { ExternalAuthGuard } from "./auth/external-auth.guard";
import { ExternalAuthInterceptor } from "./auth/external-auth-interceptor.service";
import { ExternalAuthService } from "./auth/external-auth.service";
import { LayoutModule } from "./pages/layout/layout.module";

function appInitializer(externalAuthGuard: ExternalAuthGuard) {
  return () => {};
}

registerLocaleData(localeEsAr, "es-Ar");

@NgModule({ declarations: [AppComponent, DialogConfirmComponent],
    bootstrap: [AppComponent],
    exports: [], imports: [FileMaterialModule,
        BrowserModule,
        BrowserAnimationsModule,
        SplashScreenModule,
        LayoutModule,
        TranslateModule.forRoot(),
        HighlightModule,
        ClipboardModule,
        AppRoutingModule,
        NgbModule,
        SharedModule,
        IndividualsModule], providers: [
        ExternalAuthService,
        {
            provide: LOCALE_ID,
            useValue: "es-Ar",
        },
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntl,
        },
        {
            provide: ErrorHandler,
            useClass: ChunkErrorHandler,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ExternalAuthInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
            deps: [ExternalAuthGuard],
        },
        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                coreLibraryLoader: () => import("highlight.js/lib/core"),
                languages: {
                    xml: () => import("highlight.js/lib/languages/xml"),
                    typescript: () => import("highlight.js/lib/languages/typescript"),
                    scss: () => import("highlight.js/lib/languages/scss"),
                    json: () => import("highlight.js/lib/languages/json"),
                },
            },
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
